import React from 'react';
import PropTypes from 'prop-types';

import EditIcon from 'components/icons/EditIcon';
import DeleteIcon from 'components/icons/DeleteIcon';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

const Actions = ({ onUpdate, onDelete }) => {
  return (
    <Box sx={{ display: "flex", gap: 0.5 }}>
    <IconButton
      size="small"
      onClick={onUpdate}
    >
      <EditIcon />
    </IconButton>
    <IconButton
        size="small"
        onClick={onDelete}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};

Actions.propTypes = {
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
};

export default Actions;
